import React from 'react';
import ItemVariation from '../../../organisms/FoodMenu/components/variants/item/ItemVariation';
import { MenuItemVariationPropType } from '../../../services/proptypes';
var SpecialPriceVariation = function SpecialPriceVariation(_ref) {
  var variations = _ref.variations,
    precision = _ref.precision;
  var variationsStyle = {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap'
  };
  return /*#__PURE__*/React.createElement("div", {
    style: variationsStyle
  }, variations.map(function (_ref2, index) {
    var name = _ref2.name,
      price = _ref2.price;
    return /*#__PURE__*/React.createElement(ItemVariation, {
      key: name,
      name: name,
      price: price,
      precision: precision,
      isOnlyVariation: variations.length === 1,
      isLastVariation: index === variations.length - 1
    });
  }));
};
SpecialPriceVariation.defaultProps = {
  precision: 2
};
export default SpecialPriceVariation;